// extracted by mini-css-extract-plugin
module.exports = {"card":"Indicator_card__26-HC","cardHeading":"Indicator_cardHeading__1AoP9","cardTitle":"Indicator_cardTitle__2cYoA","cardBody":"Indicator_cardBody__kmhQE"};